// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__AQbg5","pint":"Logo_pint__X13wi"};